import { useEffect } from "react";
import PropTypes from "prop-types";

const StepChangeAnalyticsEvents = ({
    currentPage,
    dataLayerOptions,
    hasSentStartAnalyticsEvents,
    hasSubmittedForm,
    sendStepChangeAnalyticsEvents,
}) => {
    useEffect(() => {
        if (hasSentStartAnalyticsEvents && !hasSubmittedForm) {
            sendStepChangeAnalyticsEvents(dataLayerOptions, currentPage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    return null;
};

StepChangeAnalyticsEvents.propTypes = {
    currentPage: PropTypes.number.isRequired,
    dataLayerOptions: PropTypes.shape({}).isRequired,
    hasSentStartAnalyticsEvents: PropTypes.bool.isRequired,
    hasSubmittedForm: PropTypes.bool.isRequired,
    sendStepChangeAnalyticsEvents: PropTypes.func.isRequired,
};

export default StepChangeAnalyticsEvents;
